/**
 * Sistema visual ticket (POS / Catálogo / producto).
 * Nuevos overlays, listas y pantallas: importar desde aquí.
 * No hardcodear #0F766E / IBM Plex / colors.background en módulos ticket.
 */
export { ticketColors, ticketFonts } from '../theme/ticketColors';
export { ticketSurfaces } from './ticketSurfaces.styles';
export { PaperSheet } from './PaperSheet';
export { ticketText } from './ticketText';
export { ticketChrome } from './ticketChrome.styles';
export { ticketControls } from './ticketControls.styles';
export { ticketList } from './ticketList.styles';
export { ensureTicketFonts, ensurePosTicketFonts } from './ensureTicketFonts';
export { ticketOperationalHeader } from './ticketOperationalHeader.styles';
export { ticketMoreActions } from './ticketMoreActions.styles';
export { TicketKpiStrip, type TicketKpiItem } from './TicketKpiStrip';
export { TicketModuleScreen, type TicketModuleScreenProps } from './TicketModuleScreen';
export { OperationalScrollScreen, type OperationalScrollScreenProps } from './OperationalScrollScreen';
export { TicketModuleHeader, type TicketModuleHeaderProps } from './TicketModuleHeader';
export { TicketModalHeader } from './TicketModalHeader';
export { TicketMoreActionsSheet, type TicketMoreAction } from './TicketMoreActionsSheet';
export { TicketButton, type TicketButtonVariant } from './TicketButton';
export { TicketField } from './TicketField';
export { TicketListRow, type TicketListRowGroup } from './TicketListRow';
export { TicketSheet } from './TicketSheet';
export { TicketDeskFooter, type TicketDeskFooterProps } from './TicketDeskFooter';
export { TicketAlertStrip, type TicketAlertStripProps, type TicketAlertStripTone } from './TicketAlertStrip';
export { ticketDeskTable } from './ticketDeskTable.styles';
